import { useEffect, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { authenticate, setAccessToken, setIdToken } from '../services/authService'

export const LoginCallback: React.FC = () => {
    const [searchParams] = useSearchParams()
    const code = searchParams.get('code')
    const [isAuthenticated, setAuthenticated] = useState<boolean | undefined>()
    useEffect(() => {
        const getToken = async (code: string) => {
            return await authenticate(code)
        }
        if (code) {
            getToken(code).then((response) => {
                if (response && response.data) {
                    const { accessToken, idToken } = response.data
                    setAccessToken(accessToken)
                    setIdToken(idToken)
                    setAuthenticated(true)
                }
            })
        }
    }, [])

    return isAuthenticated ? <Navigate to="/" replace /> : <></>
}
